var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"header"},[_vm._t("default"),_c('span',[_vm._v("Name")]),_c('span',[_vm._v("Detail")]),_c('span',[_vm._v("Latest period")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }